import AuthService from "../auth/AuthService";
import { message } from "antd";

const Auth = new AuthService();

export const fetchTotalStockValue = async () => {
    try {
        const response = await Auth.fetch("/dashboard/total-stock-value");
        return response;
    } catch (error) {
        message.error("Error fetching total stock value");
        return null;
    }
};

export const getOrder = async () => {
    try {
        const response = await Auth.fetch("/dashboard/order-quantity");
        return response;
    } catch (error) {
        message.error("Error fetching order quantity");
        return null;
    }
};

export const getOrderTrends = async () => {
    try {
        const response = await Auth.fetch("/dashboard/fulfilled-quantity-trends");
        return response;
    } catch (error) {
        message.error("Error fetching order trends");
        return null;
    }
};

export const getCategoryDistribution = async () => {
    try {
        const response = await Auth.fetch("/dashboard/quantity-distribution");
        return response;
    } catch (error) {
        message.error("Error fetching category distribution");
        return null;
    }
};

export const getWarhorseCapacity = async () => {
    try {
        const response = await Auth.fetch("/dashboard/warehouse-capacity");
        return response;
    } catch (error) {
        message.error("Error fetching warehouse capacity");
        return null;
    }
};

export const getItemsExpiry = async () => {
    try {
        const response = await Auth.fetch("/dashboard/items-expiry");
        return response;
    } catch (error) {
        message.error("Error fetching item expiry data");
        return null;
    }
};

export const getDeliverCollection = async () => {
    try {
        const response = await Auth.fetch("/dashboard/dispatched-orders-type");
        return response;
    } catch (error) {
        message.error("Error fetching dispatched orders");
        return null;
    }
};

export const getItemsBelowSafetyStock = async () => {
    try {
        const response = await Auth.fetch("/dashboard/items-below-safety-stock");
        return response;
    } catch (error) {
        message.error("Error fetching items below safety stock orders");
        return null;
    }
}